import React, { useEffect, useRef } from "react";

import { useClickOuter } from "studio-design-system";

import { ModalCloseButton } from "~/components/classLanding/components/HeroSection/ClassTrailerVideoModal/ModalCloseButton";
import { GreenCheckIcon } from "~/components/common/Icons/GreenCheckIcon";
import { useKeyDown } from "~/hooks/useKeyDown";

import * as styles from "./SuccessModal.css";

interface SuccessModalProps {
  isSuccessModalOpen: boolean;
  descriptor: string;
  creatorName: string;
  exitSuccessModal: (playImmediately?: boolean) => void;
}

const SuccessModal = ({
  isSuccessModalOpen,
  descriptor,
  creatorName,
  exitSuccessModal,
}: SuccessModalProps) => {
  const outerClickRef = useClickOuter(true, () => {
    if (isSuccessModalOpen) {
      exitSuccessModal(false);
    }
  });

  useKeyDown("Escape", () => exitSuccessModal(false), isSuccessModalOpen);

  return (
    <div
      style={{
        display: isSuccessModalOpen ? "block" : "none",
        opacity: isSuccessModalOpen ? "1" : "0",
        pointerEvents: isSuccessModalOpen ? "auto" : "none",
      }}
      className={styles.successModalOverlay}
    >
      <div
        style={{ pointerEvents: isSuccessModalOpen ? "inherit" : "none" }}
        className={styles.trailerVideoModalContainer}
      >
        <div className={styles.successModal} ref={outerClickRef}>
          <div className={styles.successModalContainer}>
            <div className={styles.successModalBody}>
              <ModalCloseButton
                width={16}
                height={16}
                className={styles.successModalX}
                onClick={() => exitSuccessModal(false)}
              />
              <div className={styles.successModalIcon}>
                <GreenCheckIcon width={60} height={60} />
              </div>
              <div>
                <p className={styles.successModalTitle}>{descriptor} added to your Library!</p>
                <p className={styles.successModalSubtitle}>
                  Ready to go behind the scenes with {creatorName}?
                </p>
              </div>
              <button onClick={() => exitSuccessModal(true)} className={styles.successModalBtn}>
                Start watching
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
